import { getEpoch, getTodayWithTime } from "./DateFormatter";

/**
 * Do the start and end dates encompass now?
 * @name isWindowOpen
 * @param {string} start
 * @param {string} end
 * @returns {bool}
 */
export const isWindowOpen = (start, end) => {
    const epochNow = getEpoch(getTodayWithTime());
    if (start && end) {
        return getEpoch(start) <= epochNow && getEpoch(end) >= epochNow;
    }

    return false;
};

/**
 * Is the districtWindow open?
 * @name isRoundOpen
 * @param {{}} districtWindow
 * @returns {bool}
 */
export const isRoundOpen = (districtWindow) => {
    if (districtWindow) {
        return isWindowOpen(districtWindow.startDate, districtWindow.endDate);
    }

    return false;
};

/**
 * Return the requested action control object
 * @name getActionControl
 * @param {string} action
 * @param {[]} actionControls
 * @param {{}} districtWindow
 * @returns {{}|null}
 */
export const getActionControl = (action, actionControls, districtWindow) => {
    const result = actionControls.filter(
        (obj) => obj.action === action && parseInt(obj.differentiator, 10) === parseInt(districtWindow.key, 10)
    );
    if (result && result.length > 0) {
        return result[0];
    }

    return null;
};

/**
 * is the specific action control open?
 * @name isAllowed
 * @param {string} action
 * @param {[]} actionControls
 * @param {{}} activeDistrictWindow
 * @param {[]} districtWindows
 * @returns {bool}
 */
export const isAllowed = (action, actionControls, activeDistrictWindow, districtWindows) => {
    if (!isRoundOpen(districtWindows[0]) && !isRoundOpen(districtWindows[1])) {
        return false;
    }

    const actionControl = getActionControl(action, actionControls, activeDistrictWindow);

    if (actionControl && isWindowOpen(actionControl.startDate, actionControl.endDate)) {
        return true;
    }

    return false;
};

/**
 * Is the PARENT_REQUEST window open for this round?
 * @name parentRequestAllowed
 * @param {[]} actionControls
 * @param {{}} activeDistrictWindow
 * @param {[]} districtWindows
 * @returns {bool}
 */
export const parentRequestAllowed = (actionControls, activeDistrictWindow, districtWindows) => {
    if (!isRoundOpen(districtWindows[0]) && !isRoundOpen(districtWindows[1])) {
        return false;
    }

    const parentRequest = getActionControl("PARENT_REQUEST", actionControls, activeDistrictWindow);

    if (isWindowOpen(parentRequest.startDate, parentRequest.endDate)) {
        return true;
    }

    return false;
};

/**
 * Specifically, are we between PARENT_REQUEST windows?
 * @name parentRequestBetweenRounds
 * @param {[]} actionControls
 * @param {{}} districtWindows
 * @returns {bool}
 */
export const parentRequestBetweenRounds = (actionControls, districtWindows) => {
    if (!isRoundOpen(districtWindows[0]) && !isRoundOpen(districtWindows[1])) {
        return false;
    }
    const parentRequest = getActionControl("PARENT_REQUEST", actionControls, districtWindows[0]); //getActionControlsWrapper(\Inspired\OpenEnrollment\DistrictWindowDao::getActiveSchoolYearKey(), \Inspired\OpenEnrollment\ActionControlType::PARENT_REQUEST, $windows['ROUND1']['key']);

    const parentRequestRoundTwo = getActionControl("PARENT_REQUEST", actionControls, districtWindows[1]); // ActionControlsDao::getActionControlsWrapper(\Inspired\OpenEnrollment\DistrictWindowDao::getActiveSchoolYearKey(), \Inspired\OpenEnrollment\ActionControlType::PARENT_REQUEST, $windows['ROUND2']['key']);

    if (isWindowOpen(parentRequest.endDate, parentRequestRoundTwo.startDate)) {
        return true;
    }

    return false;
};

/**
 * Specifically determine if the current time is between finalize round1 and parent request round2
 * @name parentViewBetweenRounds
 * @param {[]} actionControls
 * @param {[]} districtWindows
 * @returns {bool}
 */
export const parentViewBetweenRounds = (actionControls, districtWindows) => {
    if (!isRoundOpen(districtWindows[0]) && !isRoundOpen(districtWindows[1])) {
        return false;
    }
    const schoolFinalizeRoundOne = getActionControl("SCHOOL_FINALIZE", actionControls, districtWindows[0]); // ActionControlsDao::getActionControlsWrapper(\Inspired\OpenEnrollment\DistrictWindowDao::getActiveSchoolYearKey(), \Inspired\OpenEnrollment\ActionControlType::SCHOOL_FINALIZE, $windows['ROUND1']['key']);

    const parentRequestRoundTwo = getActionControl("PARENT_REQUEST", actionControls, districtWindows[1]); // ActionControlsDao::getActionControlsWrapper(\Inspired\OpenEnrollment\DistrictWindowDao::getActiveSchoolYearKey(), \Inspired\OpenEnrollment\ActionControlType::PARENT_REQUEST, $windows['ROUND2']['key']);

    if (isWindowOpen(schoolFinalizeRoundOne.startDate, parentRequestRoundTwo.startDate)) {
        return true;
    }

    return false;
};

/**
 * Specifically determine if the SCHOOL_VIEW_PARENT_OFFER window is open
 * @name schoolViewParentOfferAllowed
 * @param {[]} actionControls
 * @param {{}} activeDistrictWindow
 * @param {[]} districtWindows
 * @returns {bool}
 */
export const schoolViewParentOfferAllowed = (actionControls, activeDistrictWindow, districtWindows) => {
    if (!isRoundOpen(districtWindows[0]) && !isRoundOpen(districtWindows[1])) {
        return false;
    }

    const schoolViewParentOffer = getActionControl("SCHOOL_VIEW_PARENT_OFFER", actionControls, activeDistrictWindow);
    if (isWindowOpen(schoolViewParentOffer.startDate, schoolViewParentOffer.endDate)) {
        return true;
    }

    return false;
};

/**
 * Specifically determine if the SCHOOL_VIEW_ONLY window is open
 * @name schoolViewOnlyAllowed
 * @param {[]} actionControls
 * @param {{}} activeDistrictWindow
 * @param {[]} districtWindows
 * @returns {bool}
 */
export const schoolViewOnlyAllowed = (actionControls, activeDistrictWindow, districtWindows) => {
    if (!isRoundOpen(districtWindows[0]) && !isRoundOpen(districtWindows[1])) {
        return false;
    }
    const schoolViewOnly = getActionControl("SCHOOL_VIEW_ONLY", actionControls, activeDistrictWindow);
    if (isWindowOpen(schoolViewOnly.startDate, schoolViewOnly.endDate)) {
        return true;
    }

    return false;
};
